/**
 * MM Shop — sync filters & tabs from Categories page catalog
 */
(function (global) {
  'use strict';

  var CACHE_KEY = 'mm_catalog_cache_v2';
  var VIEWS_KEY = 'mm_cat_views_v1';
  var CACHE_TTL = 5 * 60 * 1000;

  function readViews() {
    try {
      var raw = localStorage.getItem(VIEWS_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function getViewCount(handle) {
    var views = readViews();
    var n = views[handle];
    return typeof n === 'number' && n > 0 ? n : 0;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fetchCatalog(url) {
    var localeRoot = window.MMShop ? window.MMShop.root() : '/';
    var localeBase = localeRoot.replace(/\/$/, '');
    if (localeBase && /^\/pages\//.test(url)) url = localeBase + url;
    var cached = null;
    try {
      cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
    } catch (e) { /* ignore */ }
    if (cached && cached.url === url && Date.now() - cached.ts < CACHE_TTL) {
      return Promise.resolve(cached.data);
    }

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('catalog fetch failed');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('mm-catalog-data');
        if (!el) throw new Error('catalog json missing');
        var data = JSON.parse(el.textContent);
        try {
          sessionStorage.setItem(
            CACHE_KEY,
            JSON.stringify({ url: url, ts: Date.now(), data: data })
          );
        } catch (e) { /* ignore */ }
        return data;
      });
  }

  function flattenCollections(catalog) {
    var list = [];
    (catalog.groups || []).forEach(function (g) {
      (g.collections || []).forEach(function (c) {
        list.push({
          handle: c.handle,
          title: c.title,
          url: c.url,
          count: c.count,
          image: c.image,
          searchIndex: c.searchIndex || c.title + ' ' + c.handle,
          groupId: g.id,
          groupTitle: g.title,
          groupTitleEn: g.titleEn
        });
      });
    });
    return list;
  }

  function getBrandGroup(groups) {
    return (groups || []).find(function (g) {
      var t = ((g.titleEn || g.title || '') + '').toLowerCase();
      return t.indexOf('brand') !== -1 || t.indexOf('علام') !== -1 || t.indexOf('مارك') !== -1;
    });
  }

  function brandVendorValue(collection) {
    return (collection.handle || collection.title || '')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9\u0600-\u06FF]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildBrandCheckboxes(brandGroup) {
    if (!brandGroup || !brandGroup.collections) return '';
    var html = '';
    brandGroup.collections.forEach(function (c) {
      var val = brandVendorValue(c);
      html +=
        '<label class="mmshop-chk mms-chk"><input type="checkbox" value="' +
        escapeHtml(val) +
        '" data-brand-title="' +
        escapeHtml(translatedLabel(c.title)) +
        '"><span>' +
        escapeHtml(translatedLabel(c.title)) +
        '</span></label>';
    });
    return html;
  }

  function populateBrandLists(brandGroup) {
    var html = buildBrandCheckboxes(brandGroup);
    ['mmBrands', 'mmsBrandChks', 'mmhDesktopBrands', 'mmhMobileBrands'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.innerHTML = html;
    });
  }

  function sortByPopularity(collections) {
    return collections.slice().sort(function (a, b) {
      var diff = getViewCount(b.handle) - getViewCount(a.handle);
      if (diff !== 0) return diff;
      return (a.title || '').localeCompare(b.title || '');
    });
  }

  function matchesQuery(query, haystack) {
    if (!global.MMSmartSearch) {
      return (haystack || '').toLowerCase().indexOf((query || '').toLowerCase()) !== -1;
    }
    return global.MMSmartSearch.matchesFuzzySearch(query, haystack);
  }

  function translatedLabel(value) {
    return global.MMTranslateCopy ? global.MMTranslateCopy(value) : (value || '');
  }

  function displayGroupTitle(g, locale) {
    if (!g) return '';
    var loc = (locale || '').toString().toLowerCase();
    if (loc.indexOf('ar') === 0 && g.titleAr) return translatedLabel(g.titleAr);
    return translatedLabel(g.title || g.titleEn || '');
  }

  function buildGroupAccordion(groups, locale) {
    var html = '';
    groups.forEach(function (g, idx) {
      var isBrandGroup = false;
      var t = ((g.titleEn || g.title || '') + '').toLowerCase();
      if (t.indexOf('brand') !== -1 || t.indexOf('علام') !== -1) return;

      var open = idx === 0 ? ' is-open' : '';
      html +=
        '<div class="mm-cf-group' +
        open +
        '" data-group-id="' +
        escapeHtml(g.id) +
        '">';
      html +=
        '<button type="button" class="mm-cf-head" aria-expanded="' +
        (idx === 0 ? 'true' : 'false') +
        '">';
      html += '<span class="mm-cf-title">' + escapeHtml(displayGroupTitle(g, locale)) + '</span>';
      html +=
        '<span class="mm-cf-count">' +
        (g.collections ? g.collections.length : 0) +
        '</span>';
      html +=
        '<svg class="mm-cf-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>';
      html += '</button>';
      html += '<ul class="mm-cf-list">';
      (g.collections || []).forEach(function (c) {
        html +=
          '<li class="mm-cf-item" data-search-index="' +
          escapeHtml((c.searchIndex || c.title || '') + ' ' + translatedLabel(c.title)) +
          '">';
        html +=
          '<button type="button" class="mm-cf-btn mmshop-catalog-col" data-url="' +
          escapeHtml(c.url) +
          '" data-title="' +
          escapeHtml(translatedLabel(c.title)) +
          '"><span class="mm-cf-btn__label">' +
          escapeHtml(translatedLabel(c.title)) +
          '</span><span class="mm-cf-btn__count">' +
          (c.count || 0) +
          '</span></button></li>';
      });
      html += '</ul></div>';
    });
    return html;
  }

  function buildTabButtons(collections, limit, allUrl, allLabel, className) {
    var html =
      '<button type="button" class="' +
      className +
      ' on" data-url="' +
      escapeHtml(allUrl) +
      '" data-title="' +
      escapeHtml(allLabel) +
      '">' +
      escapeHtml(allLabel) +
      '</button>';
    sortByPopularity(collections)
      .slice(0, limit)
      .forEach(function (c) {
        html +=
          '<button type="button" class="' +
          className +
          '" data-url="' +
          escapeHtml(c.url) +
          '" data-title="' +
          escapeHtml(translatedLabel(c.title)) +
          '">' +
          escapeHtml(translatedLabel(c.title)) +
          '</button>';
      });
    return html;
  }

  function buildModalChips(collections) {
    var html = '';
    collections.forEach(function (c) {
      html +=
        '<button type="button" class="mms-dd-chip mmshop-catalog-col" data-url="' +
        escapeHtml(c.url) +
        '" data-cat-title="' +
        escapeHtml(translatedLabel(c.title)) +
        '" data-search-index="' +
        escapeHtml((c.searchIndex || c.title || '') + ' ' + translatedLabel(c.title)) +
        '">' +
        escapeHtml(translatedLabel(c.title)) +
        '</button>';
    });
    return html;
  }

  function bindAccordion(container) {
    if (!container) return;
    container.addEventListener('click', function (e) {
      var head = e.target.closest('.mm-cf-head');
      if (!head) return;
      var group = head.closest('.mm-cf-group');
      if (!group) return;
      var open = group.classList.contains('is-open');
      container.querySelectorAll('.mm-cf-group').forEach(function (g) {
        g.classList.remove('is-open');
        var h = g.querySelector('.mm-cf-head');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        group.classList.add('is-open');
        head.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function filterCatalogItems(container, query) {
    if (!container) return;
    var items = container.querySelectorAll('[data-search-index]');
    items.forEach(function (el) {
      var hay = el.getAttribute('data-search-index') || el.textContent;
      var show = matchesQuery(query, hay);
      el.style.display = show ? '' : 'none';
      var group = el.closest('.mm-cf-group');
      if (group && show) group.classList.add('is-open');
    });
    container.querySelectorAll('.mm-cf-group').forEach(function (g) {
      var shown = 0;
      g.querySelectorAll('.mm-cf-item').forEach(function (item) {
        if (item.style.display !== 'none') shown++;
      });
      if (query && shown === 0) g.style.display = 'none';
      else g.style.display = '';
    });
  }

  function init(config) {
    if (!config || !config.catalogUrl || !config.autoCatalog) return Promise.resolve(null);

    return fetchCatalog(config.catalogUrl)
      .then(function (catalog) {
        var flat = flattenCollections(catalog);
        var groups = catalog.groups || [];
        var brandGroup = getBrandGroup(groups);
        var filterGroups = groups.filter(function (g) {
          return g !== brandGroup;
        });

        populateBrandLists(brandGroup);

        var locale = catalog.locale || config.locale || '';

        var desktopGroups = document.getElementById('mmCatalogGroups');
        if (desktopGroups) {
          desktopGroups.innerHTML = buildGroupAccordion(
            filterGroups.length ? filterGroups : groups,
            locale
          );
          bindAccordion(desktopGroups);
        }

        var filterSearch = document.getElementById('mmCatalogFilterSearch');
        if (filterSearch && desktopGroups) {
          filterSearch.addEventListener('input', function () {
            filterCatalogItems(desktopGroups, filterSearch.value.trim());
          });
        }

        var mmTabs = document.getElementById('mmTabs');
        if (mmTabs) {
          mmTabs.innerHTML = buildTabButtons(
            flat,
            config.tabLimit || 10,
            config.allUrl,
            config.allLabel,
            'mmshop-tab'
          );
        }

        var mmsTabs = document.getElementById('mmsTabs');
        if (mmsTabs) {
          mmsTabs.innerHTML = buildTabButtons(
            flat,
            config.tabLimit || 10,
            config.allUrl,
            config.allLabelShort || config.allLabel,
            'mms-tab'
          );
        }

        var mobileFilter = document.getElementById('mmMobileCatalogFilters');
        if (mobileFilter) {
          mobileFilter.innerHTML = buildGroupAccordion(
            filterGroups.length ? filterGroups : groups,
            locale
          );
          bindAccordion(mobileFilter);
          var mSearch = document.getElementById('mmMobileCatalogFilterSearch');
          if (mSearch) {
            mSearch.addEventListener('input', function () {
              filterCatalogItems(mobileFilter, mSearch.value.trim());
            });
          }
        }

        var homeDesktopGroups = document.getElementById('mmhDesktopCatalogGroups');
        if (homeDesktopGroups) {
          homeDesktopGroups.innerHTML = buildGroupAccordion(
            filterGroups.length ? filterGroups : groups,
            locale
          );
          bindAccordion(homeDesktopGroups);
          var homeDesktopSearch = document.getElementById('mmhDesktopCatalogFilterSearch');
          if (homeDesktopSearch) {
            homeDesktopSearch.addEventListener('input', function () {
              filterCatalogItems(homeDesktopGroups, homeDesktopSearch.value.trim());
            });
          }
        }

        var homeMobileFilter = document.getElementById('mmhMobileCatalogFilters');
        if (homeMobileFilter) {
          homeMobileFilter.innerHTML = buildGroupAccordion(
            filterGroups.length ? filterGroups : groups,
            locale
          );
          bindAccordion(homeMobileFilter);
          var homeMobileSearch = document.getElementById('mmhMobileCatalogFilterSearch');
          if (homeMobileSearch) {
            homeMobileSearch.addEventListener('input', function () {
              filterCatalogItems(homeMobileFilter, homeMobileSearch.value.trim());
            });
          }
        }

        var ddChips = document.querySelector('#mmsDDCats .mms-dd-chips');
        if (ddChips) {
          ddChips.innerHTML = buildModalChips(flat);
        }

        var homeDdChips = document.querySelector('#mmhDDCats [data-mm-catalog-modal-chips], [data-mm-catalog-modal-chips]');
        if (homeDdChips && homeDdChips.closest('#mmhDDCats')) {
          homeDdChips.innerHTML = buildModalChips(flat);
        }

        var homeQuickTabs = document.getElementById('mmhQuickTabs');
        if (homeQuickTabs) {
          homeQuickTabs.innerHTML = buildTabButtons(
            flat,
            config.tabLimit || 10,
            config.allUrl,
            config.allLabelShort || config.allLabel || 'All',
            'mmh-quick-tab'
          );
          homeQuickTabs.hidden = false;
        }

        var legacyCats = document.getElementById('mmCats');
        var legacyGoals = document.getElementById('mmGoals');
        if (legacyCats) legacyCats.style.display = 'none';
        if (legacyGoals && legacyGoals.closest('.mmshop-fsec')) {
          legacyGoals.closest('.mmshop-fsec').style.display = 'none';
        }

        var legacyCatChips = document.getElementById('mmsCatChips');
        var legacyGoalChips = document.getElementById('mmsGoalChips');
        if (legacyCatChips && legacyCatChips.closest('.mms-fgroup')) {
          legacyCatChips.closest('.mms-fgroup').style.display = 'none';
        }
        if (legacyGoalChips && legacyGoalChips.closest('.mms-fgroup')) {
          legacyGoalChips.closest('.mms-fgroup').style.display = 'none';
        }

        if (typeof config.onReady === 'function') {
          config.onReady(catalog, flat, brandGroup);
        }

        return catalog;
      })
      .catch(function (err) {
        console.warn('[MMShopCatalog]', err);
        if (typeof config.onFallback === 'function') config.onFallback();
        return null;
      });
  }

  global.MMShopCatalog = {
    init: init,
    fetchCatalog: fetchCatalog,
    flattenCollections: flattenCollections,
    getBrandGroup: getBrandGroup,
    populateBrandLists: populateBrandLists,
    sortByPopularity: sortByPopularity,
    matchesQuery: matchesQuery,
    brandVendorValue: brandVendorValue
  };
})(typeof window !== 'undefined' ? window : globalThis);
